import {Drawer} from "@mui/material";
import {Box} from "@mui/system";

export default function ModalDrawer({open, ModalProps = {disableRestoreFocus: true}, sx= {zIndex: 3000}, children}) {
    return <Drawer
        anchor="bottom"
        open={open}
        ModalProps={ModalProps}
        sx={sx}
    >
        <Box sx={{p: 2}}>
            {children}
        </Box>
    </Drawer>
}